<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="row container">
        <div class="col-xs-12 col-sm-4 col-lg-3">
          <div class="card card-inverse card-success">
            <div class="card-block p-1">
              <div class="h4 m-a-0">{{ session.balance | toMoney(session.currency) }}</div>
              <div>{{ t.remaining_limit }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER')
            && !session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL')">
        <div class="card-block">
          <div class="row container">
            <div class="form-group col-sm-3">
              <label>{{ t.custom_reseller_panel.search_client }}</label>
              <CustomerSearch usageArea="client"></CustomerSearch>
            </div>
          </div>
          <div class="row container">
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'CustomerCreate'}" class="btn btn-primary btn-block">{{ t.custom_reseller_panel.new_client }}</router-link>
            </div>
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'LimitRequest'}" class="btn btn-primary btn-block">{{ t.custom_reseller_panel.limit_request }}</router-link>
            </div>
          </div>
          <div class="row container">
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'CustomerList'}" class="btn btn-primary btn-block">
                {{ t.clients }}
              </router-link>
            </div>
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'AccountCasino'}" class="btn btn-primary btn-block">
                {{ t.accounting.title }}
              </router-link>
            </div>
          </div>
          <div class="row container">
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'CardBayi'}" class="btn btn-primary btn-block">
                {{ t.navigation.bets }}
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL') && !session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
        <div class="card-block">
          <div class="row container">
            <div class="form-group col-sm-3">
              <label>{{ t.custom_reseller_panel.search_reseller}}</label>
              <CustomerSearch usageArea="reseller"></CustomerSearch>
            </div>
            <div class="form-group col-sm-3">
              <label>{{ t.custom_reseller_panel.search_client }}</label>
              <CustomerSearch usageArea="client"></CustomerSearch>
            </div>
          </div>
          <div class="row container">
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'AdminCreate'}" class="btn btn-primary btn-block">
                {{ t.custom_reseller_panel.new_client }}
              </router-link>
            </div>
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'LimitRequest'}" class="btn btn-primary btn-block">
                {{ t.custom_reseller_panel.limit_request }}
              </router-link>
            </div>
          </div>

        </div>
      </div>
      <div class="card" v-if="session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
        <div class="card-block">
          <div class="row container">
            <div class="form-group col-sm-3">
              <label>{{ t.custom_reseller_panel.search_administrator || 'Search Admin' }}</label>
              <CustomerSearch usageArea="admin"></CustomerSearch>
            </div>
            <div class="form-group col-sm-3">
              <label>{{ t.custom_reseller_panel.search_reseller}}</label>
              <CustomerSearch usageArea="reseller"></CustomerSearch>
            </div>
          </div>
          <div class="row container">
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'AdminCreate'}" class="btn btn-primary btn-block">
                {{ t.custom_reseller_panel.new_client }}
              </router-link>
            </div>
            <div class="form-group col-xs-6 col-sm-3">
              <router-link :to="{name: 'LimitRequest'}" class="btn btn-primary btn-block">
                {{ t.custom_reseller_panel.limit_request }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="display: none;">
        <div class="card-header">
          Duyurular
        </div>
        <div class="card-block">
          <ul>
            <li style="list-style-type:none">Hafta kapanış saati pazartesiyi salıya bağlayan gece 03:00 olarak
              güncellenmiştir.<br>Çekim işlemlerini saat 02:55e kadar lütfen tamamlayınız.
            </li>
          </ul>
        </div>
      </div>
      <AdminStats v-if="session.roles.includes('ROLE_CREATE_SUB_RESELLER') || session.roles.includes('ROLE_RESELLER_MANAGEMENT_FULL')" />
    </div>
  </div>
</template>

<script>
import AdminStats from "./AdminStats";
import CustomerSearch from "../CustomerSearch";
export default {
  name: "Home",
  components: {CustomerSearch, AdminStats},
  data() {
    return {
      session: session,
      t: this.$root.t
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue